import React from "react";
import { MainBackgroundWrapper } from "modules/non-protected-page/shared";

import {
  serverRoutes,
  templateServerRouteBySlug,
} from "client-server-shared/config/routes";
import {
  Container,
  ResponsiveText,
} from "modules/marketing-pages/front-page/shared";
import { PageHeadTags } from "common/head-tags";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { locale } from "client-server-shared/constants";
import Link from "next/link";
import { Description, Typography } from "components/ui/Typography";
import { colors } from "src/constants";
import { TemplatesContainer } from "modules/templates/templates-list";

const MainHero = () => {
  return (
    <MainBackgroundWrapper
      component="section"
      sx={{
        background: colors.white1,
        textAlign: "center",
        padding: "124px 0 24px 0",
      }}
    >
      <ResponsiveText
        variant="h1"
        fontSize={50}
        sx={{
          position: "relative",
          maxWidth: "700px",
          margin: "auto",
          color: colors.black1,
        }}
      >
        Free AI-powered AI Writing Generators & Tools
      </ResponsiveText>
      <ResponsiveText
        fontSize={20}
        sx={{
          color: colors.gray1,
          maxWidth: "600px",
          margin: "24px auto 0px auto",
        }}
      >
        Explore more than 200+ AI-powered writing tools to enhance your content
        creation, streamline workflows, and boost productivity effortlessly.
      </ResponsiveText>
    </MainBackgroundWrapper>
  );
};

export default function Page() {
  return (
    <>
      <PageHeadTags
        noAlternative
        pageLink={serverRoutes.tools}
        title={"AI-Powered Writing Tools"}
        description="Explore the best AI-powered writing tools to enhance your content creation, streamline workflows, and boost productivity effortlessly."
      />
      <MainHero />

      <Container
        component="section"
        sx={{
          margin: "72px auto",
        }}
      >
        <TemplatesContainer
          onServer
          getNavigateProps={(slug) => {
            return {
              component: Link,
              href: templateServerRouteBySlug(slug),
            };
          }}
        />
      </Container>
    </>
  );
}
export async function getStaticProps() {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}
